/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import { gridWithGap } from './summary.helper';

const useStyles = makeStyles(() => ({
  container: {
    ...gridWithGap,
  },
  span3: {
    ...gridWithGap,
    gridColumn: 'span 3',
  },
  span6: {
    ...gridWithGap,
    gridColumn: 'span 6',
  },
  bodyCard: {
    height: 'max-content',
  },
}));

/**
 * Responsive Summary component with cards for the main submission components that gets used
 * in the Submission form and for the sending confirmation screen.
 * @returns {JSX.Element}
 * @constructor
 */
export default function MediumSummary({ receiptCard, orderedBodyCards, dialog }) {
  const classes = useStyles();

  const leftColumn = orderedBodyCards
    .map((card, index) => (index % 2 === 0 ? card : null))
    .filter(item => item != null);

  const rightColumn = orderedBodyCards
    .map((card, index) => (index % 2 !== 0 ? card : null))
    .filter(item => item != null);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.span3}>{receiptCard}</div>
        <Divider className={classes.span6} />
        <div className={clsx(classes.span3, classes.bodyCard)}>{leftColumn}</div>
        <div className={clsx(classes.span3, classes.bodyCard)}>{rightColumn}</div>
      </div>
      {dialog}
    </>
  );
}
